/* eslint-disable import/no-named-as-default-member */
import _ from "lodash";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import Select from "react-select";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from '@material-ui/icons/Check';
import {TextField} from "@material-ui/core";
import {
    TwoDecimalPercentFormat,
    DollarAndCentFormat,
    FloatFormat,
    TwoDecimalFloatFormat,
} from 'components/Notifications/FormattedInputs';

import {getLoanProceedAssumptions, saveLoanProceedAssumptions, applyToExistingFinancing} from 'store/state/loan/loan';
import {getConfigItemByParentId} from 'store/state/configItems';
import {INTEREST_RATE_TYPE, FLOATING_INDICES, FIXED_INDICES,AMORTIZATION_TYPE,DAY_TYPES} from "constants/configItemParents";
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import { setConfigItemListState } from "components/Global/Fields/util";

import { ToastError } from "components/Global/Toasts/Toasty";

const loanTypes = require("constants/loanTypes");

const StyledTextField = styled(TextField)`
  max-width: 100px;
`;

const PageContainer = styled.div`
    
`;

const FinanceButton = styled.button`
border: none;
background-color: inherit;
font-size: 16px;
cursor: pointer;
display: inline-block;
font-family: 'WORK SANS';
color: #005AA9;
`

const TitleBar = styled.div`
  && {
    font-size: 24px;
    marign-top: 25px;
    margin-bottom: 25px;
  }
`;

const PrettyTable = styled.table`
border-spacing: 0px;
`

const GreyHeader = styled.thead`
background-color: #f9f9f9;
color: black
`

const HeaderCell = styled.th`
&& {
    border-bottom: 3px solid #eeeeee;
    font-weight: 500;
    font-size: 14px;
    max-width:100px;
    padding-left: 15px;
    padding-right: 15px;
    font-family: work sans
    text-align: center;
}
`

const UniformCell = styled.td`
    border-bottom: 1px solid #eeeeee;
    padding-top: 5px;
    max-width:100px;
    font-size:14px;
    font-family: work sans
    padding-bottom: 5px;
`;

const HeaderGroupCell = styled.td`
    text-align:center;
`;

class LoanProceedSettingsPage extends Component {
    state = {
        hasTransitionedAssumptionsIntoState: false,
        formattedAssumptions: null,
        prevAssumptions: null,
        interestRateTypes: [],
        floatingIndices: [],
        fixedIndices: [],
        amortizationTypes: [],
        dayCountTypes: []
    }

    componentDidMount () {
      this.props.getConfigItemByParentId({ id: INTEREST_RATE_TYPE });
      this.props.getConfigItemByParentId({ id: FLOATING_INDICES });
      this.props.getConfigItemByParentId({ id: FIXED_INDICES });
      this.props.getConfigItemByParentId({ id: AMORTIZATION_TYPE });
      this.props.getConfigItemByParentId({id: DAY_TYPES});
      this.props.getLoanProceedAssumptions({companyId: this.props.authentication.user.contact.companyId});
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.configItems && this.props.configItems.configItemByParent) {
            setConfigItemListState(INTEREST_RATE_TYPE, "interestRateTypes", this);
            setConfigItemListState(FLOATING_INDICES, "floatingIndices", this);
            setConfigItemListState(FIXED_INDICES, "fixedIndices", this);
            setConfigItemListState(AMORTIZATION_TYPE, "amortizationTypes", this);
            setConfigItemListState(DAY_TYPES, "dayCountTypes", this)
        }
    }

    standardizeFormattedNumber = (value) => {
        let convertedValue = 0;
        if(typeof value === "string"){
            if(value.length > 1){
                if(value.includes("%")){
                    convertedValue = parseFloat(value.substring(0, value.length-1));
                }
                if(value.includes("$")){
                    convertedValue = parseFloat(value.replace(/,/g,"").substring(1, value.length));
                }
            } else{
                return parseFloat(value);
            }
        }
        if(convertedValue > 999999999999){
            convertedValue = 999999999999; //max number the db can hold
        }
        return convertedValue || parseFloat(value.replace(/,/g,""));
    }
    
    getAssumptions = () => {
        const rawAssumptions = this.props.assumptions || [];
        if(rawAssumptions.length === 0) return [];
        if(this.state.hasTransitionedAssumptionsIntoState){
            return this.state.assumptions;
        }
        
        let formattedAssumptions = [];
        for(let i = 0; i < rawAssumptions.length; i++) {
            let raw = rawAssumptions[i];
            formattedAssumptions.push({
                name: loanTypes.loanTypeList.filter(x=>x.value===raw.loanType)[0].label,
                loanType: raw.loanType,
                term: raw.term || 0,
                amortization: raw.amortization || 0,
                loanSpread: raw.loanSpread? raw.loanSpread : 0,
                UwRate: raw.UwRate? raw.UwRate : 0,
                minDSCR: raw.minDSCR || 0,
                minDebtYield: raw.minDebtYield ? raw.minDebtYield : 0,
                maxLTV: raw.maxLTV ? raw.maxLTV : 0,
                companyId: this.props.authentication.user.contact.companyId,
                rateTypeId: raw.rateTypeId,
                indexId: raw.indexId,
                amortizationTypeId: raw.amortizationTypeId,
                amortizationTerm: raw.amortizationTerm,
                amortizationRate: raw.amortizationRate,
                interestOnlyPeriods: raw.interestOnlyPeriods,
                dayCountId: raw.dayCountId,
                closingCosts: raw.closingCosts
            });
        }
        formattedAssumptions = _.sortBy(formattedAssumptions,"name");
        this.setState({hasTransitionedAssumptionsIntoState: true, assumptions: formattedAssumptions, prevAssumptions: _.cloneDeep(formattedAssumptions)});
        return formattedAssumptions;
    }
    
    handleSave = () => {
        this.setState({prevAssumptions: _.cloneDeep(this.state.assumptions)});
        this.props.saveLoanProceedAssumptions({assumptions: this.state.assumptions});
    }

    handleCancel = () => {
        this.setState({assumptions: this.state.prevAssumptions});
        ToastError("Changes Canceled");
    }

    handleApplicationToExistingFinancing = (loanType) => {
        this.setState({prevAssumptions: _.cloneDeep(this.state.assumptions)});
        this.props.applyToExistingFinancing({loanType, assumptions:this.state.assumptions});
    }


  render() {
    return (
    <PageContainer>
        <TitleBar>
            LOAN PROCEEDS ASSUMPTIONS
            <SecondaryButton style={{marginLeft: "20px"}} onClick={this.handleCancel}><CloseIcon style={{marginRight:5}}/>CANCEL</SecondaryButton>
            <SecondaryButton onClick={this.handleSave}><CheckIcon style={{marginRight:5}}/>SAVE SETTINGS</SecondaryButton>
        </TitleBar>
        <PrettyTable>
            <GreyHeader>
                <tr style={{height:"48px"}}>
                    <td colspan="9" style={{border: "1px solid #DADCE0", textAlign: "center", fontSize:"16px", fontWeight: "lighter", color:"#005AA9"}}>
                        Underwriting Assumptions
                    </td>
                    <td colspan="7" style={{border: "1px solid #DADCE0", textAlign: "center", fontSize:"16px", fontWeight: "lighter", color:"#005AA9"}}>
                        Cashflow Assumptions
                    </td>
                </tr>
                <tr style={{height:"48px"}}>
                    <HeaderCell style={{maxWidth:"130px"}}>Loan Type</HeaderCell>
                    <HeaderCell>Amortization<br/>(m)</HeaderCell>
                    <HeaderCell>Loan Spread</HeaderCell>
                    <HeaderCell>Interest Rate<br/>Type</HeaderCell>
                    <HeaderCell>Rate Index</HeaderCell>
                    <HeaderCell>Underwr. Rate<br/>(Floating)</HeaderCell>
                    <HeaderCell>Min DSCR</HeaderCell>
                    <HeaderCell>Min Debt Yield</HeaderCell>
                    <HeaderCell>Max LTV</HeaderCell>
                    <HeaderCell>Loan Term (m)</HeaderCell>
                    <HeaderCell>Amort Type</HeaderCell>
                    <HeaderCell>Amort Term (m)</HeaderCell>
                    <HeaderCell>Amort Rate<br/>(Floating)</HeaderCell>
                    <HeaderCell>I/O Periods</HeaderCell>
                    <HeaderCell>Day Count</HeaderCell>
                    <HeaderCell>Closing Costs</HeaderCell>
                </tr>
            </GreyHeader>
            {this.renderRows()}
        </PrettyTable>
    </PageContainer>);
  }


  updateField = (assumptionObject, fieldName, value, type) => {
    let newAssumptions = this.state.assumptions;
    if(type && type === "list")
        newAssumptions.filter(x=>x.loanType===assumptionObject.loanType)[0][fieldName] = value;
    else
        newAssumptions.filter(x=>x.loanType===assumptionObject.loanType)[0][fieldName] = this.standardizeFormattedNumber(value);
    this.setState({assumptions: newAssumptions});
  }


  renderRows = () => {
    let out = [];
    let assumptionRecords = this.getAssumptions();
    
    
    for(let i = 0; i < assumptionRecords.length; i++){
        let type = assumptionRecords[i];
        let optionsList = [];
        if(type.rateTypeId && type.rateTypeId === "5813c493-4681-11e9-82f6-0242ac120002")
            optionsList = this.state.floatingIndices;
        else if(type.rateTypeId && type.rateTypeId === "53669856-4681-11e9-82f6-0242ac120002")
            optionsList = this.state.fixedIndices;

        const indexIdDisabled = !type.rateTypeId;

        out.push(
            <React.Fragment>
                <tr style={{position:"relative"}}>
                    <UniformCell style={{width:"130px", whiteSpace: "nowrap"}}>{type.name}</UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "integer",
                            value: type.amortization,
                            onBlur: event => {
                                this.updateField(type, "amortization", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "percent",
                            value: type.loanSpread.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "loanSpread", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>{this.renderInput({ type: "list", value: type.rateTypeId, options: this.state.interestRateTypes, placeholder: "Rate Type", onChange: event => {this.updateField(type, "rateTypeId", event.value, "list"); }})}</UniformCell>
                    <UniformCell>{this.renderInput({ type: "list", isDisabled: indexIdDisabled, value: type.indexId, options: optionsList, placeholder: "Rate Index", onChange: event => {this.updateField(type, "indexId", event.value, "list"); }})}</UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "percent",
                            value: type.UwRate.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "UwRate", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "decimal",
                            value: type.minDSCR.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "minDSCR", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "percent",
                            value: type.minDebtYield.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "minDebtYield", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "percent",
                            value: type.maxLTV.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "maxLTV", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "integer",
                            value: type.term,
                            onBlur: event => {
                                this.updateField(type, "term", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>{this.renderInput({ type: "list", value: type.amortizationTypeId, options: this.state.amortizationTypes, placeholder: "", onChange: event => {this.updateField(type, "amortizationTypeId", event.value, "list"); }})}</UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "integer",
                            value: type.amortizationTerm,
                            onBlur: event => {
                                this.updateField(type, "amortizationTerm", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "percent",
                            value: type.amortizationRate?.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "amortizationRate", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "integer",
                            value: type.interestOnlyPeriods,
                            onBlur: event => {
                                this.updateField(type, "interestOnlyPeriods", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <UniformCell>{this.renderInput({ type: "list", value: type.dayCountId, options: this.state.dayCountTypes, placeholder: "", onChange: event => {this.updateField(type, "dayCountId", event.value, "list"); }})}</UniformCell>
                    <UniformCell>
                        {this.renderInput({
                            type: "percent",
                            value: type.closingCosts?.toFixed(2),
                            onBlur: event => {
                                this.updateField(type, "closingCosts", event.target.value);
                            }
                        })}
                    </UniformCell>
                    <div style={{position:"absolute", width:"150px", marginLeft:"30px"}}>
                        <FinanceButton onClick={()=> {this.handleApplicationToExistingFinancing(type.loanType)}}>Apply changes to<br/>existing financing</FinanceButton>
                    </div>
                </tr>
            </React.Fragment>
        );
    }
    return out;
    }


    renderInput = ({type, defaultValue, onChange, onBlur, style, internalLabel, value, options, placeholder, isDisabled}) => {
        let inputProps = {
        style:{
            textAlign: "center", 
            transition: '0.3s',
            }
        };
        switch(type){
            case 'money':
                inputProps.inputComponent = DollarAndCentFormat;
                break;   
            case 'percent':
                inputProps.inputComponent = TwoDecimalPercentFormat;
                break;
            case 'integer':
                inputProps.inputComponent = FloatFormat;
                break;
            case "decimal":
                inputProps.inputComponent = TwoDecimalFloatFormat;
                break;            
            default:
                break;
        }
        if(type === "list")
        return (
            <Select
              id={internalLabel+"Dropdown"}
              fullWidth
              name={internalLabel}
              styles={{
                control: (provided, state) => ({ ...provided, boxShadow: 'none', border:'none', padding: 0  }),
                indicatorSeparator: (provided, state) => ({ ...provided, display:'none' }),
                container: (provided, state) => ({ ...provided, borderBottom: '.99px solid rgb(167, 167, 167);', transition: 'border 0.1s', '&:hover': { cursor: 'pointer', borderBottom: '.99px solid rgb(167, 167, 167);' }, 
                padding: '0', marginBottom: '9px;', marginRight: '5px;'
            }),
            }}
              options={options}
              onChange={onChange}
              placeholder={placeholder}
              menuPlacement="auto"
              value={options.find(
                option => option.value === value
              )}              
              isDisabled={isDisabled}
            />
        )
        else
            return (<StyledTextField 
                        defaultValue = {defaultValue}
                        InputProps = {inputProps}
                        onChange = {onChange}
                        onBlur = {onBlur}
                        label = {internalLabel}
                        style={style}
                        value = {value}
                    />)
    }
}




function mapStateToProps({ authentication, loan, configItems }) {
  return {
      authentication,
      assumptions: loan.loanProceedAssumptions,
      configItems
  };
}

export default compose(
  connect(mapStateToProps, {
    getLoanProceedAssumptions,
    saveLoanProceedAssumptions,
    getConfigItemByParentId,
    applyToExistingFinancing
  })
)(LoanProceedSettingsPage);
